import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import CdHome from "./components/CdHome.vue"
import CdCar from "./components/CdCar.vue"
import CdOrder from "./components/CdOrder.vue"
import EnterPrise from "./components/enterprise.vue"
Vue.use(Router);

export default new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    {path: '/', redirect: '/login'},
    {
      path: '/login',
      name: 'login',
      component: () =>
        import("./views/login.vue")
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      children: [
        {
          path: '/',
          component: CdHome
        }, {
          path: '/cdCar',
          component: CdCar
        }, {
          path: '/cdOrder',
          component: CdOrder
        }, {
          path: '/enterPrise',
          component: EnterPrise
        }
      ]
    },
    {
      path: "/about",
      name: "about",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/About.vue")
    },{
      path:'*',
      // hidden: true,
      redirect: { path: '/login' }
    }
  ]
});
